import { compile } from 'path-to-regexp';

export const toPath = (pattern: any, params: any, search = '') => {
  return compile(pattern, { encode: encodeURIComponent })(params) + search;
};
